import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Expenses</h3>
                <p className="text-sm text-gray-600">
                    Track all financial transactions and costs related to your fleet operations.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Adding Expenses</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Expense</strong> to log a new cost.</li>
                    <li>Specify the <strong>Amount</strong>, <strong>Category</strong> (e.g., Service, Fuel, Parts), and <strong>Vendor</strong>.</li>
                    <li>Link the expense to a <strong>Vehicle</strong> or a specific <strong>Job</strong> for accurate tracking.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Categorization</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Categories:</strong> Help group costs for financial reporting.</li>
                    <li><strong>Payment Methods:</strong> Track how the expense was paid (e.g., Credit Card, Cash).</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Reporting and Exports</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use <strong>Date Range Picker</strong> to filter expenses by time.</li>
                    <li>Search by vendor or category to find specific transactions.</li>
                    <li>Export your data to <strong>PDF</strong> or <strong>CSV</strong> for accounting purposes.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
